import { useState } from 'react';
import { tracking } from '@iwoca/frontend-tracking-library';
import { IconGearOutline } from '@iwoca/icons';
import { Button } from '@iwoca/orion';
import { Trans } from '@lingui/macro';
import { MonthsFilter } from 'components/DashboardSettings/MonthsFilter/MonthsFilter';
import { Drawer } from 'components/Drawer/Drawer';
import { useIntroducerContext } from 'contexts/IntroducerContext/IntroducerContext';
import { getAmplitudeDefaultEventProperties } from 'utils/amplitudeEvents';
import { ColumnSettings } from './ColumnSettings/ColumnSettings';
import { ColumnToggles } from './ColumnToggles/ColumnToggles';
import styles from './DashboardSettings.module.css';
import { DateRangeFilter } from './DateRangeFilter/DateRangeFilter';
import { ManagedByIwocaSwitch } from './ManagedByIwocaSwitch/ManagedByIwocaSwitch';
import { ManagedByIwocaToggle } from './ManagedByIwocaToggle/ManagedByIwocaToggle';

export const DashboardSettings = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { checkIntroducerPermission, splitTests } = useIntroducerContext();
  const showNewDashboard = splitTests?.hasAccessToNewDashboard;

  const handleToggle = () => {
    tracking.ampli.ctaClick({
      ...getAmplitudeDefaultEventProperties(),
      'CTA text': 'Dashboard settings',
    });
    setIsOpen((prevIsOpen) => !prevIsOpen);
  };

  return (
    <>
      <Button
        data-testid="dashboard-settings-toggle-button"
        onClick={handleToggle}
        variant="tertiary"
        className={styles.toggleButton}
      >
        <IconGearOutline className={styles.icon} />
        <Trans>Dashboard settings</Trans>
      </Button>
      <Drawer show={isOpen} onClose={handleToggle}>
        {showNewDashboard ? <DateRangeFilter /> : <MonthsFilter />}
        <hr className={styles.divider} />
        {checkIntroducerPermission('can_see_partner_applications') && (
          <>
            {showNewDashboard ? (
              <ManagedByIwocaToggle />
            ) : (
              <ManagedByIwocaSwitch />
            )}
            <hr className={styles.divider} />
          </>
        )}
        {showNewDashboard ? <ColumnToggles /> : <ColumnSettings />}
      </Drawer>
    </>
  );
};
